export default "__VITE_ASSET__ty2rCV1z__"